import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { BrandSelectors } from '@amfam/shared/utility/brand';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel, DsModalService } from '@amfam/ui-kit';

import { AddPaymentMethodFailureCount } from '../../../../feature/src/lib/+state/common.action';
import * as billingSharedSelectors from '../../../../feature/src/lib/+state/common.selectors';

@Component({
  selector: 'ds-add-payment-method-failure-modal',
  templateUrl: './add-payment-method-failure-modal.component.html',
  standalone: false
})
export class AddPaymentFailureModalComponent implements OnInit {
  public confirmationData!: ConfirmationModel;
  helpDeskNumber: string;
  tryAgainCounter: number;
  status = 'error' as const;

  constructor(
    private store: Store,
    private copyService: CopyService,
    private modalService: DsModalService
  ) {}

  ngOnInit() {
    this.store
      .select(BrandSelectors.selectECUnderWrittingCustServicePhoneNum)
      .pipe(take(1))
      .subscribe(custServPhoneNum => {
        this.helpDeskNumber = custServPhoneNum;
      });
    this.store
      .select(billingSharedSelectors.selectAddPaymentMethodFailureCount)
      .pipe(take(1))
      .subscribe(counter => {
        this.tryAgainCounter = counter;
      });

    this.confirmationData = {
      confirmation: {
        heading: this.copyService.getCopy('billing.addPaymentMethodFailureHeading'),
        status: this.status
      },
      ctaArea: {
        button: {
          title: 'Try again',
          callback: this.onClickOfTryAgain.bind(this)
        }
      }
    };
  }

  //Closing the modal after 3 Fail attempts
  handleClose(): void {
    this.modalService.closeAll();
  }

  onClickOfTryAgain(): void {
    if (this.tryAgainCounter >= 2) {
      this.store.dispatch(
        AddPaymentMethodFailureCount({
          addPaymentMethodFailureCount: 0
        })
      );
      const newConfirmationData = {
        confirmation: {
          heading: this.copyService.getCopy('billing.failureAttemptsHeading'),
          infoText: this.copyService.getCopy('billing.failureAttemptsSubHeading', {
            helpDeskNumber: this.helpDeskNumber
          }),
          status: this.status
        },
        ctaArea: {
          button: {
            title: 'Close',
            callback: this.handleClose.bind(this)
          }
        }
      };
      this.confirmationData = { ...this.confirmationData, ...newConfirmationData };
    } else {
      this.store.dispatch(
        AddPaymentMethodFailureCount({
          addPaymentMethodFailureCount: this.tryAgainCounter++
        })
      );
    }
    this.modalService.closeAll();
    this.modalService.open('choosePaymentMethod');
  }
}
